import React from 'react';
import PropTypes from 'prop-types';
import FormattedListValue from '@/shared/components/FormattedListValue';
import SimplePanel from '@/shared/components/SimplePanel';
import { injectIntl, FormattedMessage, FormattedDate } from 'react-intl';
import moment from 'moment';
import messages from '../jobMessages';
import Checkbox from '@/shared/components/input/Checkbox';
import FormattedDateShort from '../../../shared/components/FormattedDateShort';

const JobDetailCreateRegistration = ({ job, intl }) => {
  // Some json parameters might still be stored without camelcase in the db, so convert it to camelcase just in case
  const { parameters } = job;

  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Date} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <FormattedDateShort value={parameters.date} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.What} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <FormattedListValue
                  list="resourcecategory"
                  id={parameters.resource.id}
                  fallback={parameters.resource.name}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Quantity} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                {parameters.resource.type === 0 &&
                  `${parameters.durationMinutes} ${intl.formatMessage(messages.MinutesLowerCase)}`}
                {parameters.resource.type !== 0 && `${parameters.quantity}`}
              </div>
            </div>
          </div>

          <div className="col-lg-5">
            <div className="row">
              <div className="col-md-8 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Billable} />
                  </b>
                </label>
              </div>
              <div className="col-md-4 col-sm-6">
                <Checkbox value={job.parameters.isBillable} onClick={() => {}} />
              </div>
            </div>
            {parameters.resource.type === 0 && (
              <div className="row">
                <div className="col-md-8 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.StartTime} />
                    </b>
                  </label>
                </div>
                <div className="col-md-4 col-sm-6">
                  {moment(parameters.startTime, 'HH:mm:ss').format('HH:mm')}
                </div>
              </div>
            )}
            {parameters.taskTemplateId && (
              <div className="row">
                <div className="col-md-8 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.Task} />
                    </b>
                  </label>
                </div>
                <div className="col-md-4 col-sm-6">
                  <FormattedListValue
                    list="tasktemplate"
                    id={parameters.taskTemplateId}
                    fallback=""
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {parameters.remark && (
          <React.Fragment>
            <div className="row">
              <div className="col-lg-11">
                <div className="row">
                  <div className="col-md-12">
                    <label>
                      <b>
                        <FormattedMessage {...messages.Remark} />
                      </b>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-11">
                <div className="row">
                  <div className="col-md-12">{parameters.remark}</div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
        {parameters.internalRemark && (
          <React.Fragment>
            <div className="row">
              <div className="col-lg-11">
                <div className="row">
                  <div className="col-md-12">
                    <label>
                      <b>
                        <FormattedMessage {...messages.InternalRemark} />
                      </b>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-11">
                <div className="row">
                  <div className="col-md-12">{parameters.internalRemark}</div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </SimplePanel>
  );
};

JobDetailCreateRegistration.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailCreateRegistration);
